import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
//* DayJS
import dayjs from 'dayjs'
//* Components
import MyButton from '../../util/MyButton'
import Comments from './Comments'
import CommentForm from './CommentForm'
import LikeButton from './LikeButton'
//* Material UI
import withStyles from '@material-ui/core/styles/withStyles'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import UnfoldMore from '@material-ui/icons/UnfoldMore'
import ChatIcon from '@material-ui/icons/Chat'
//* Redux
import { useDispatch, useSelector } from 'react-redux'
import { getChirp, clearErrors } from '../../redux/actions/dataActions'

const styles = (theme) => ({
  ...theme.spreadThis,
  closeButton: {
    position: 'absolute',
    left: '90%',
  },
  expandButton: {
    position: 'absolute',
    left: '90%',
  },
  spinnerDiv: {
    textAlign: 'center',
    marginTop: 50,
    marginBottom: 50,
  },
})

const ChirpDialog = ({ classes, chirpId, userHandle }) => {
  //* Redux
  const dispatch = useDispatch()
  const {
    chirp: { body, createdAt, likeCount, commentCount, userImage, comments },
  } = useSelector((state) => state.data)
  const { loading } = useSelector((state) => state.UI)

  //* State
  const [open, setOpen] = useState(false)
  const [oldPath, setOldPath] = useState('')
  // eslint-disable-next-line
  const [newPath, setNewPath] = useState('')

  //* Event Handlers
  const handleOpen = () => {
    let oldPath = window.location.pathname
    const newPath = `/users/${userHandle}/chirp/${chirpId}`
    if (oldPath === newPath) oldPath = `/users/${userHandle}`
    window.history.pushState(null, null, newPath)
    setOpen(true)
    setOldPath(oldPath)
    setNewPath(newPath)
    dispatch(getChirp(chirpId))
  }

  const handleClose = () => {
    window.history.pushState(null, null, oldPath)
    setOpen(false)
    dispatch(clearErrors())
  }

  const dialogMarkup = loading ? (
    <div className={classes.spinnerDiv}>
      <CircularProgress size={200} thickness={2} />
    </div>
  ) : (
    <Modal container spacing={8}>
      <SelectedChirp>
        <DialogImage item sm={5}>
          <img src={userImage} alt='Profile' />
        </DialogImage>
        <DialogContents item sm={7}>
          <Typography
            component={Link}
            color='primary'
            variant='h5'
            to={`/users/${userHandle}`}
          >
            @{userHandle}
          </Typography>
          <hr className={classes.invisibleSeparator} />
          <Typography variant='body2' color='textSecondary'>
            {dayjs(createdAt).format('h:mm a, MMMM DD YYYY')}
          </Typography>
          <hr className={classes.invisibleSeparator} />
          <Typography variant='body1'>{body}</Typography>
          <LikeButton chirpId={chirpId} />
          <span>{likeCount}</span>
          <MyButton tip='comments'>
            <ChatIcon color='primary' />
          </MyButton>
          <span>{commentCount}</span>
        </DialogContents>
      </SelectedChirp>
      {/* <hr /> */}
      <CommentForm chirpId={chirpId} />
      <Comments comments={comments} />
    </Modal>
  )

  return (
    <>
      <MyButton
        onClick={handleOpen}
        tip='Expand chirp'
        tipClassName={classes.expandButton}
      >
        <UnfoldMore color='primary' />
      </MyButton>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
        <MyButton
          tip='Close'
          onClick={handleClose}
          tipClassName={classes.closeButton}
        >
          <CloseBtn />
        </MyButton>
        <DialogContent className={classes.DialogContent}>
          {dialogMarkup}
        </DialogContent>
      </Dialog>
    </>
  )
}

const Modal = styled(Grid)`
  overflow-x: hidden;
  @media (max-width: 768px) {
  }
`
const SelectedChirp = styled.div`
  width: 100%;
  display: flex;
`
const DialogImage = styled(Grid)`
  padding: 0rem 1rem 1rem 3rem;
  img {
    max-width: 150px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    margin-top: 60px;
    padding: 0;
  }
  @media (max-width: 600px) {
    padding: 0rem 1rem;
    img {
      width: 100px;
      height: 100px;
    }
  }
`
const DialogContents = styled(Grid)`
  margin-top: 60px;
  padding: 0;
`

const CloseBtn = styled(CloseIcon)`
  @media (max-width: 768px) {
    transform: translateX(-25px);
  }
`
ChirpDialog.propTypes = {
  chirpId: PropTypes.string.isRequired,
  userHandle: PropTypes.string.isRequired,
}

export default withStyles(styles)(ChirpDialog)
